import { render, staticRenderFns } from "./StepperButtons.vue?vue&type=template&id=024646c1&scoped=true&"
import script from "./StepperButtons.vue?vue&type=script&lang=js&"
export * from "./StepperButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024646c1",
  null
  
)

export default component.exports